/**
 * SportsFooter Component - Created by cazarez on 07/02/18.
 */
import * as React from 'react'
import { Container, Title, Text, FooterLink, TitleBottom } from './styledComponents'
import messages from './messages'
import Span from '../Common/UnderlinedLink'
import UnderlinedLink from '../Common/UnderlinedLink'

interface Props {
  formatMessage: (messageDescriptor: any) => string
  history?: any
  footerLinks?: any[]
  currentRegion: string
  currentLanguage: string
  currentCurrency?: string
}
const sports = [
  { name: 'Road | Gravel', path: '/road-bike' },
  { name: 'MTB | BMX', path: '/mountain-bike' },
  { name: 'Triathlon', path: '/triathlon' },
  { name: 'Run', path: '/run' },
  { name: 'Nordic Ski', path: '/nordic' },
  { name: 'Casual', path: '/casual' },
]
const SportsFooter = ({ formatMessage, currentRegion, currentCurrency, currentLanguage, footerLinks }: Props) => {
  const openUrl = (evt: React.MouseEvent<HTMLDivElement>) => {
    const {
      currentTarget: { id }
    } = evt
    if (id) {
      const path = `${id}/${currentRegion}?lang=${currentLanguage || 
        'en'}&currency=${currentCurrency}`
      window.location.replace(path)
    }
  }
  return (
    <Container>
      <Title>{formatMessage(messages.title)}</Title>
      {sports.map(({ name: linkName, path }, key: number) =>
        <Text {...{ key }} onClick={openUrl} id={path}>
          <Span id={path} noClick={true} link={path}>{linkName}</Span>
        </Text>
      )}
      {footerLinks && footerLinks.length > 0 && 
        <FooterLink>
          <TitleBottom>{formatMessage(messages.sitePages)}</TitleBottom>
          {footerLinks ? 
            footerLinks.map(({ name, route }, key: number) => 
              <Text {...{ key }}>
                <UnderlinedLink {...{ history }} link={`/${route}`}>
                  {name}
                </UnderlinedLink>
              </Text>
            ) : null
          }
        </FooterLink>
      }
    </Container>
  )
}

export default SportsFooter



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SportsFooter/index.tsx